<template>
  <div class="toast-container">
    <div
      v-for="(toast) in toasts"
      :key="toast.id"
      class="pb-4"
    >
      <sn-toast
        :key="toast.id"
        v-model="toast.active"
        class="sn-toast"
        :event="toast.event"
        :message="toast.message"
        :description="toast.description"
        :type="toast.type"
        :action-text="toast.actionText"
        :action-data="toast.actionData"
        v-on="$listeners"
      />
    </div>

    <span
      :class="{ 'toast-queue-visible': toasts.length > 5 }"
      class="toast-queue-full-warning"
    >
      Review alerts above to see queue
    </span>
  </div>
</template>
<script>

import SnToast from '~/components/snui/v2/snToast/snToast'

export default {
  name: 'SnToaster',
  components: { SnToast },
  props: {
    toasts: {
      type: Array,
      required: true
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.toast-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 2000;
}
.sn-toast {
  margin-top: 10px !important;
  margin-bottom: 12px !important;
  margin-left: auto !important;
  max-width: 340px !important;
  z-index: 2001 !important;
  position: relative;
  display: flex;
  pointer-events: auto;
}
.sn-toast:nth-last-of-type(n+6) {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear, translateY(60px) 0s 2s
}
.toast-queue-full-warning {
  display: flex;
  justify-content: right;
  margin: -24px -72px 24px 0;
  color: $sn-primary-lighten-2;
  opacity: 0;
  transition: opacity 0.5s, margin 0.5s;
}
.toast-queue-full-warning.toast-queue-visible {
  opacity: 1;
  margin: -24px 24px 24px 0;
}
</style>
